import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchResources } from 'store/getResourcesSlice';
import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import ProductCards from 'components/ProductCards/index';
import image from 'images/small-images-inside-text/Image.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';

const Resources = () => {
    const dispatch = useDispatch();
    const {
        fs_title,
        fs_view_button,
        fs_title_background,
        crop_nutrition_programs,
        trial_results,
        information_materials,
    } = useSelector(state => state?.resources?.data?.data) || {};
    useEffect(() => {
        dispatch(fetchResources());
    }, [dispatch]);

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />
            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            Discover valuable resources
                            <br />
                            <em>
                                to enhance your <img src={image} alt="decor" /> agricultural journey
                            </em>
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Explore our{' '}
                                <em>
                                    complex crop nutrition programs and the results
                                    <br />
                                    of our trials
                                </em>{' '}
                                to learn how to care for your plants for optimal yields.
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>
            <ProductCards data={[crop_nutrition_programs, trial_results, information_materials]} />
        </>
    );
};

export default Resources;
